import {store} from "../store";
import {lessonPlayerStore} from "./LessonPlayerStore";

class SegmentDataProvider {
  #previousIsDemoSoundEnabledReduxValue: boolean | undefined;
  #isDemoModeSoundEnabledChangedSubscribers: ((isDemoSoundEnabled: boolean) => void)[] = [];

  constructor() {
    store.subscribe(() => {
      this.#onDemoModeEnabled_potentiallyChanged();
    });
  }

  // Consider moving to a hook
  subscribeToIsDemoSoundEnabledChanged(callback: (isDemoSoundEnabled: boolean) => void, notifyOnAdd: boolean = true): void {
    this.#isDemoModeSoundEnabledChangedSubscribers.push(callback);
    if (notifyOnAdd) {
      const isDemoSoundEnabled = lessonPlayerStore.getIsDemoLeftHandSoundEnabled() || lessonPlayerStore.getIsDemoRightHandSoundEnabled();
      callback(isDemoSoundEnabled);
    }
  }

  #onDemoModeEnabled_potentiallyChanged(): void {
    const isDemoSoundEnabled = lessonPlayerStore.getIsDemoLeftHandSoundEnabled() || lessonPlayerStore.getIsDemoRightHandSoundEnabled();
    const hasChanged = isDemoSoundEnabled !== this.#previousIsDemoSoundEnabledReduxValue;
    this.#previousIsDemoSoundEnabledReduxValue = isDemoSoundEnabled;

    if (hasChanged) {
      this.#isDemoModeSoundEnabledChangedSubscribers.forEach(subscriber => subscriber(isDemoSoundEnabled));
    }
  }

  resetDemoModeSubscribers(): void {
    this.#isDemoModeSoundEnabledChangedSubscribers = [];
  }

  resetAllSubscribers(): void {
    this.resetDemoModeSubscribers();
  }
}

const segmentDataProvider = new SegmentDataProvider();
export default segmentDataProvider;